
import React, { useState } from 'react';
import CustomModal from '../../../Modal/CustomModal';
import FacePhoto from '../PhotoWebcam/FacePhoto';
import CustomMultipleApp from '../../Functionality/CustomMultipleApp';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import PickerFileUploadGallery from './PickerFileUploadGallery';

/**
 * Component for selecting or taking multiple photos, used within a modal; in that case,
   the video stream will be displayed in a separate modal.

 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param string id: component identifier
 * @param model accept: file formats and sizes accepted by the component
 * @param model photoPickerFile: component model
 * @param useState setPhotoPickerFile: state to update the component model
 * @param string titleInput: title of the dashed-line component (file selection)
 * @param boolean required:  default value is false, must be set to true if the field is required
 * @param boolean disabled: for the disabled component
 * @param boolean showBtnCamera: default value is false, must be set to true if the camera option is needed
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param className heightInput: To define the size of the file upload component
 * @param boolean emptyFields: default value is false
 * @param showBtnDeleteItemGallery: If true, the delete icon is displayed in the file gallery (FilesGallerySummary).
 * @param inModal: Indicates whether the component is being used in a modal; if so, the camera component will be displayed in a separate modal
 * @param setDisplayModal: Required when used inside a modal
 * @param titleWebcam: Title displayed when the camera video stream is active
 * @param titlePreviewWebcam: Title shown after a photo is taken, along with informational text in the preview of the captured image
 * @param titleModalCamera: Title used for the modal where the camera component is displayed
 */
const PhotoPickerMultipleModal = (
    {
        id,
        accept,
        photoPickerFile,
        setPhotoPickerFile,
        titleInput = 'drag_your_file_or',
        required,
        disabled,
        showBtnCamera,
        validateFace = false,
        heightInput = '',
        emptyFields,
        showBtnDeleteItemGallery,
        setDisplayModal,
        titleWebcam = '',
        titlePreviewWebcam = '',
        titleModalCamera = 'take_photography'
    }
) => {

    const [startup, setStartup] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isCameraSelected, setIsCameraSelected] = useState(false);
    const { t } = useTranslation();

    const { handleAddFile, isFileAdditionDone } = CustomMultipleApp({ photoPickerFile, setPhotoPickerFile });

    return (
        <>
            <CustomModal
                title={titleModalCamera}
                show={showModal}
                display={isCameraSelected ? '' : 'd-none'}
                onHide={() => {
                    setPhotoPickerFile(prev => ({
                        ...prev,
                        selfieSrc: null
                    }));
                    setStartup(false);
                    setShowModal(false);
                    if (setDisplayModal) setDisplayModal('')
                }}
                onConfirm={() => {
                    if (isFileAdditionDone()) {
                        toast.info(t("a_photo_has_not_been_taken_yet"));
                        return;
                    }
                    handleAddFile();
                    setStartup(false);
                    setShowModal(false);
                    if (setDisplayModal) setDisplayModal('')
                }}
            >
                <div className='row'>
                    <div className='col-12'>
                        <FacePhoto
                            photoPickerFile={photoPickerFile}
                            setPhotoPickerFile={setPhotoPickerFile}
                            startup={startup}
                            setStartup={setStartup}
                            validateFace={validateFace}
                            showModalSuggestion={false}
                            setIsCameraSelected={setIsCameraSelected}
                            setDisplayModal={setDisplayModal}
                            titleWebcam={titleWebcam}
                            titlePreviewWebcam={titlePreviewWebcam}
                        />
                    </div>
                </div>
            </CustomModal>

            <PickerFileUploadGallery
                id={id}
                accept={accept}
                photoPickerFile={photoPickerFile}
                setPhotoPickerFile={setPhotoPickerFile}
                titleInput={titleInput}
                required={required}
                disabled={disabled}
                showBtnCamera={showBtnCamera}
                validateFace={validateFace}
                heightInput={heightInput}
                emptyFields={emptyFields}
                showBtnDeleteItemGallery={showBtnDeleteItemGallery}
                handleStartupWebcam={() => {
                    setShowModal(true);
                    setStartup(true);
                    if (setDisplayModal) setDisplayModal('d-none')
                }}
            />

        </>
    );

}

export default PhotoPickerMultipleModal;
